import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import {
  AddThirdPartyAccessInterface,
  toExpirationDays,
} from '../../../models/dashboard/settings/third-party-access.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';

const useCreateThirdPartyAccess = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { businessInfo } = useAppSelector((state) => state.businessInfoData);

  const onCreateThirdPartyAccessError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ?? 'Something went wrong while adding third-party access.',
    );
  };

  const onCreateThirdPartyAccessSuccess = (email: string, callback: () => void) => ({
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(`We've emailed ${email} a link to generate their key.`);
    callback();
  };

  const createThirdPartyAccess = (data: AddThirdPartyAccessInterface, callback: () => void) => {
    const url: HttpConfig = {
      url: `api/v1/partner-api-keys`,
      method: 'post',
      data: {
        partnerName: data.name.trim(),
        partnerEmail: data.email.trim(),
        environment: businessInfo?.isTestMode ? 'Test' : 'Live',
        expirationDays: toExpirationDays(data.expiresAt),
      },
    };

    request(url, onCreateThirdPartyAccessSuccess(data.email, callback), setLoading, onCreateThirdPartyAccessError);
  };

  return { createThirdPartyAccess, loading };
};

export default useCreateThirdPartyAccess;
